// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"6a8595a5","977":"29f28a92"}[chunkId] + ".chunk.js";
};